import { Button } from '@/components/_ui/Button'
import Image from 'next/image'

type Props = {
  itemCount: number
  setItemCount: (itemCount: number) => void
}

export const QuantityControls = ({ itemCount, setItemCount }: Props) => {
  const handleIncrementQuantity = () => {
    setItemCount(itemCount + 1)
  }

  const handleDecrementQuantity = () => {
    if (itemCount > 1) {
      setItemCount(itemCount - 1)
    }
  }

  return (
    <div className="flex h-[40px] w-[100px] items-center justify-between rounded-full border border-secondary md:w-[152px]">
      <Button
        onClick={() => handleDecrementQuantity()}
        variant="icon"
        className="ml-2 rounded-full p-1 md:ml-3"
        data-test="product-quantity-decrement"
      >
        <Image src="/icons/minus.svg" height={20} width={20} alt="Minus" />
      </Button>
      <span data-test="product-quantity">{itemCount}</span>
      <Button
        onClick={() => handleIncrementQuantity()}
        variant="icon"
        className="mr-2 rounded-full p-1 md:mr-3"
        data-test="product-quantity-increment"
      >
        <Image src="/icons/plus.svg" height={20} width={20} alt="Plus" />
      </Button>
    </div>
  )
}
